import { useSimulatorStore } from '../../stores/useSimulatorStore';
import { ElasticityCurve } from './ElasticityCurve';
import { ElasticityTable } from './ElasticityTable';
import { RevenueWaterfall } from './RevenueWaterfall';
import { DemandCurveChart } from './DemandCurveChart';
import { VALID_PRICES } from '../../data/conjointData';
import { formatPrice } from '../../lib/formatters';
import { Select } from '../common/Select';
import { InsightCard } from '../ai/InsightCard';
import { InfoButton } from '../common/Tooltip';

export function PriceExplorerTab() {
  const selectedPrice = useSimulatorStore(s => s.selectedPrice);
  const setSelectedPrice = useSimulatorStore(s => s.setSelectedPrice);

  return (
    <div>
      <InsightCard tabId="price" />

      <div className="flex items-center gap-4 mb-6">
        <label className="text-sm text-secondary flex items-center gap-1">Selected Price: <InfoButton helpKey="selectedPrice" size={11} /></label>
        <Select
          value={selectedPrice}
          options={VALID_PRICES.map(p => ({ value: p, label: formatPrice(p) }))}
          onChange={v => setSelectedPrice(parseInt(v))}
          className="w-40"
        />
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
        <ElasticityCurve selectedPrice={selectedPrice} />
        <DemandCurveChart />
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <div className="hidden md:block">
          <ElasticityTable selectedPrice={selectedPrice} />
        </div>
        <RevenueWaterfall selectedPrice={selectedPrice} />
      </div>
    </div>
  );
}
